export default __webpack_public_path__ + "static/media/daiict.bb7c4f94.png";